import React, {useState, useEffect} from "react";
import Programate from "../../components/layout/footer";
import FormLogin from "../../components/login";
import ModalAlertMicrosoft from "../../components/shared/modals//modalAlertMicrosoft";
import { useLocation } from 'react-router-dom';
import { BACKGROUND_IMAGES } from "../../config/images";

const FRONTED_URL = process.env.REACT_APP_FRONTEND_URL;
const TENANT_ID = process.env.REACT_APP_TENANT_ID;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;

export default function Login() {
    const location = useLocation();

    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [showMicrosoftModal, setShowMicrosoftModal] = useState(false);
    const [microsoftError, setMicrosoftError] = useState("");

    useEffect(() => {
        if (location.state?.microsoftAuthError) {
            setMicrosoftError(location.state.microsoftAuthError);
            setShowMicrosoftModal(true);
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    const openLoginModal = () => {
        setIsLoginOpen(true);
    };

    const closeLoginModal = () => {
        setIsLoginOpen(false);
    };

    const closeMicrosoftModal = () => {
        setShowMicrosoftModal(false);
        setMicrosoftError("");
    };

    return (
        <div className="relative z-10 flex items-end justify-center w-full min-h-screen pt-10 pb-6 bg-center bg-cover bg-tasa">

            <img src={BACKGROUND_IMAGES.FIGURE_GREEN} alt="triangle-figure" className="absolute z-40 short:w-[8%]  w-[20%] bottom-[30%] sm:bottom-[40%] lg:w-[16%] lg:bottom-[10%] 2xl:bottom-[20%] left-0 "/>
            <img src={BACKGROUND_IMAGES.FIGURE_BLUE} alt="blue-figure" className="absolute z-20 short:w-[45%]  w-full lg:w-[60%] bottom-0 left-0 "/>
            <img src={BACKGROUND_IMAGES.FIGURE_LIGHT_BLUE} alt="lightblue-figure" className="absolute z-30 short:w-[42%] w-full lg:w-[50%] bottom-0 right-0 "/>
            <img src={BACKGROUND_IMAGES.LOGO} alt="logo-tasa" className="absolute z- short:w-[18%] w-[35%] lg:w-[12%] top-3 left-4 "/>
            <img src={BACKGROUND_IMAGES.LINES_GREEN} alt="lines-figure" className="absolute short:w-[8%] z-30 w-[20%] lg:w-[7%] top-3 right-0 "/>

            <div className="relative z-50">
                <div className="flex flex-col items-center justify-center gap-10 pt-5">
                    <div className="flex flex-col items-center justify-center gap-4">
                         <button 
                         onClick={openLoginModal}
                         className="text-white w-[240px] md:w-[313px] cursor-pointer rounded-lg font-itcdemi bg-green  py-[15px] lg:py-4 px-2 sm:px-6  text-center md:text-lg text-sm">
                        Iniciar sesión
                        </button>
                
                        <button 
                        className="text-white w-[240px] md:w-[313px] cursor-pointer rounded-lg font-itcdemi bg-[#184A7D] py-[15px] lg:py-4 sm:px-6 px-2 text-center md:text-lg text-sm"
                        onClick={() => {
                            const redirectUri = encodeURIComponent(FRONTED_URL + "/auth/microsoft");
                            const scope = encodeURIComponent("openid profile email User.Read");

                            const microsoftAuthUrl = `https://login.microsoftonline.com/${TENANT_ID}/oauth2/v2.0/authorize?client_id=${CLIENT_ID}&response_type=code&redirect_uri=${redirectUri}&scope=${scope}&response_mode=query`;
                            
                            window.location.href = microsoftAuthUrl;
                        }}>
                        Ingresar usuario office 365
                        </button>
                    </div>  
                    <Programate fontSize="text-xs md:text-base"/>          
                </div>
                <FormLogin fonts isOpen={isLoginOpen} onClose={closeLoginModal}/>

                <ModalAlertMicrosoft 
                    showModalAlertMicrosoft={showMicrosoftModal}
                    closeModal={closeMicrosoftModal}
                    error={microsoftError}
                    accept={closeMicrosoftModal}
                    color="#CA2D00"
                />
            </div>
        </div>        
    );
}